(function () {
  var currentLang = "es";

  function applyLang(dictSet, lang) {
    document.documentElement.lang = lang;
    var dict = dictSet[lang];
    if (!dict) return;
    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      var key = el.getAttribute("data-i18n");
      if (dict[key] === undefined) return;
      if (el.tagName === "LABEL") {
        var child = el.querySelector("input, textarea");
        el.textContent = dict[key];
        if (child) el.appendChild(child);
      } else {
        el.textContent = dict[key];
      }
    });
    document.querySelectorAll("[data-i18n-aria]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-aria");
      if (dict[key] !== undefined) el.setAttribute("aria-label", dict[key]);
    });
  }

  window.IncapimaSetupLang = function (dictSet) {
    applyLang(dictSet, currentLang);
    var btn = document.getElementById("langToggle");
    if (btn) {
      btn.addEventListener("click", function () {
        currentLang = currentLang === "es" ? "en" : "es";
        applyLang(dictSet, currentLang);
      });
    }
  };

  window.IncapimaSetupHero = function () {
    var heroSlides = document.querySelectorAll(".hero-slide");
    var heroDots = document.querySelectorAll(".hero-dot");
    var heroSection = document.getElementById("hero");
    if (!heroSection || !heroSlides.length) return;
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var heroIndex = 0;
    var heroTimer = null;

    function showHeroSlide(i) {
      heroIndex = (i + heroSlides.length) % heroSlides.length;
      heroSlides.forEach(function (s) { s.classList.remove("is-active"); });
      heroDots.forEach(function (d) { d.classList.remove("is-active"); });
      heroSlides[heroIndex].classList.add("is-active");
      heroDots[heroIndex].classList.add("is-active");
    }
    function startHeroAutoplay() {
      stopHeroAutoplay();
      if (prefersReducedMotion) return;
      heroTimer = setInterval(function () { showHeroSlide(heroIndex + 1); }, 6000);
    }
    function stopHeroAutoplay() {
      if (heroTimer) clearInterval(heroTimer);
    }
    var nextBtn = document.getElementById("heroNext");
    var prevBtn = document.getElementById("heroPrev");
    if (nextBtn) nextBtn.addEventListener("click", function () { showHeroSlide(heroIndex + 1); startHeroAutoplay(); });
    if (prevBtn) prevBtn.addEventListener("click", function () { showHeroSlide(heroIndex - 1); startHeroAutoplay(); });
    heroDots.forEach(function (d) {
      d.addEventListener("click", function () {
        showHeroSlide(parseInt(d.getAttribute("data-goto"), 10));
        startHeroAutoplay();
      });
    });
    heroSection.addEventListener("mouseenter", stopHeroAutoplay);
    heroSection.addEventListener("mouseleave", startHeroAutoplay);
    startHeroAutoplay();
  };

  document.addEventListener("DOMContentLoaded", function () {
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var revealEls = document.querySelectorAll(".reveal");
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { revealObserver.observe(el); });

    function animateCount(el) {
      var target = parseInt(el.getAttribute("data-target"), 10);
      if (prefersReducedMotion) { el.textContent = target; return; }
      var duration = 1200;
      var start = performance.now();
      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        el.textContent = Math.floor(progress * target);
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = target;
      }
      requestAnimationFrame(tick);
    }

    var statCounts = document.querySelectorAll(".stat-count");
    var statObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          statObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    statCounts.forEach(function (el) { statObserver.observe(el); });
  });
})();
